import {
    OpxViewNames,
    ROUTE_TO_VIEW_DEFINITIONS_OPX,
    ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK,
} from './routeViewNames';

/**
 * Determines if path matches a given route:
 * `/opx/${opxdeeplinkView}` or /opx/<mailbox>/${opxdeeplinkView}` or `/opxdeeplink/{opxdeeplinkView}`
 *  and returns the associated HostedScenario value
 *
 */
const OPX_VDIR = 'opx';
const OPXDEEPLINK_URL_SEGMENT = 'opxdeeplink';

export function getHostedScenarioByUrl(): string | undefined {
    const path = window.location ? window.location.pathname : '';
    const segments = path.split('/');
    const opxSegment = segments.indexOf(OPX_VDIR);
    if (opxSegment >= 0 && segments.length > opxSegment + 1) {
        let nextSegment = opxSegment + 1;
        if (segments[nextSegment].match(/.+@.+/)) {
            nextSegment += 1;
        }
        const route = segments[nextSegment] as OpxViewNames;
        return ROUTE_TO_VIEW_DEFINITIONS_OPX[route];
    }
    const opxdeeplinkSegment = segments.indexOf(OPXDEEPLINK_URL_SEGMENT);
    if (opxdeeplinkSegment >= 0 && segments.length > opxdeeplinkSegment + 1) {
        const route = segments[opxdeeplinkSegment + 1] as OpxViewNames;
        return ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK[route];
    }

    return undefined;
}
